import React, { useState, useEffect, useRef } from "react";
import ProductCard from "../../../../components/ProductCard/ProductCard";
import AuthenticationForm from "../../../../containers/SignInOutForm/Form";
import { AuthContext } from "../../../../contexts/auth/auth.context";
import { SearchContext } from "../../../../contexts/search/search.context";
import { useCart } from "../../../../contexts/cart/use-cart";
import {
  ProductsRow,
  ProductsCol,
  ProductCardWrapper,
  FilterWrapper,
  FilterDiv,
  FilterModalWrapper,
  Prev,
  Next,
  ErrorModal,
  ProductTopTitle,
} from "./Products.style";
import { CURRENCY } from "../../../../helper/constant";
import { useLocation, useHistory, useParams } from "react-router-dom";
import Button from "../../../../components/Button/Button";
import NoResultFound from "../../../../components/NoResult/NoResult";
import QuickView from "../../../../containers/QuickView/QuickView";
import { Modal, Spinner } from "react-bootstrap";
import Loader from "../../../../components/Loader/Loader";
import _ from "lodash";
import { cats } from "../../../../helper/constant";
import expressService from "../../../../services/expressService";
import t from "../../../../i18n/translate";
import SidebarFilter from "../../../../components/SideBarFilter/SideBarfilter";
import defaultBrandLogo from "../../../../assets/icons/delishop_logo2.svg";
import { logPageView, logViewItem } from "../../../../services/googleAnalytics";

export const Products = ({
  deviceType,
  type,
  // ptype = "usual",
  fetchLimit = 50,
  loadMore = true,
  props,
  storeId,
  textSearch,
  isExtra,
  brandName,
  isFilterModal,
  toggleFilter,
  setSelectedBrands,
  queryFilter,
  isFullWidth,
  onSeenProduct
}) => {
  const { isloading, disableloading, updateItem } = useCart();
  //   // Quick View Modal
  const [show, setShow] = useState(false);
  const [isBrandFilter, setBrandFilter] = useState(false);
  const [checked, setChecked] = useState(false);
  const [selected, setSelected] = useState([]);
  const [selectedCat, setSelectedCat] = useState([]);
  const [selectedSubCat, setSelectedSubCat] = useState([]);
  const [filterShow, setFilterShow] = useState(false);
  const [brandname, setBrandName] = useState("");
  const [brandinfo, setBrandInfo] = useState("");
  const [loader, setLoader] = useState(false);
  const [bvalues, setBValues] = useState([]);
  const [catvalues, setCatValues] = useState([]);
  const [subCatvalues, setSubCatValues] = useState([]);
  const [itemCategory, setItemCategory] = useState([]);
  const [allCategory, setAllCategory] = useState([]);
  const [showFilterNotFound, setShowFilterNotFound] = useState(false);
  ///////////// brand filter modal //////////////
  const [isBrandSelected, setBrandSelected] = useState({});

  const SUB_CAT_ID = localStorage.getItem("sub_cat_id");
  const CAT_ID = localStorage.getItem("cat_id");
  const onHide = () => setShow(false);
  const onClose = () => setBrandFilter(false);
  const [isOutOfStock, setIsOutOfStock] = useState(0);
  const [isFilter, setIsFilter] = useState(null);
  const [catId, setCatId] = useState([]);
  const lang = localStorage.getItem("lang") || "en";
  const [displayExpressMultiLabel, setDisplayExpressMultiLabel] =
    useState(false);

  const {
    authState: { isAuthenticated },
    authDispatch,
  } = React.useContext(AuthContext);
  const { state, searchdispatch } = React.useContext(SearchContext);
  const [showform, setShowForm] = useState(false);
  const handleJoin = () => {
    authDispatch({
      type: "SIGNIN",
    });
    setShowForm(true);
  };

  const handleQuickViewModal = (modalProps, deviceType, index) => {
    props.ProductModalData(modalProps);

    setShow(true);
    trackClick(modalProps, index);
    trackDetails(modalProps, index);
  };
  const trackClick = (item, index) => {
    //track click
    window.analytics &&
      window.analytics.track("Product Clicked", {
        product_id: item.item_id,
        sku: item.product_code,
        category: item.cat_id,
        name: item.name,
        brand:
          item.list_brands &&
          item.list_brands[0] &&
          item.list_brands[0].brand_name
            ? item.list_brands[0].brand_name
            : "",
        variant: item.name,
        price: item.store_items_price_types[0].price,
        quantity: 1,
        position: index + 1,
      });
  };
  const trackDetails = (item, index) => {
    //track click
    window.analytics &&
      window.analytics.track("Product Viewed", {
        product_id: item.item_id,
        sku: item.product_code,
        category: item.cat_id,
        name: item.name,
        brand:
          item.list_brands &&
          item.list_brands[0] &&
          item.list_brands[0].brand_name
            ? item.list_brands[0].brand_name
            : "",
        variant: item.name,
        price: item.store_items_price_types[0].price,
        quantity: 1,
        position: index + 1,
        currency: "USD",
        value: item.store_items_price_types[0].price,
      });
  };

  let { pathname, search } = useLocation();
  let history = useHistory();
  const location = useLocation();
  const isInViewport = () => {
    let screenWidth = 1200;
    if (window.screen.width < 800) {
      screenWidth = 1000;
    }
    if (
      window.innerHeight + window.scrollY >=
        document.body.offsetHeight - screenWidth &&
      props.page >= 1 &&
      props.isHasMore
    ) {
      // User has scrolled to the bottom, load more products
      if (document.getElementById("showMore")) {
        setLoader(true);
        document.getElementById("showMore").click();
        handleLoadmore();
      } else {
        setLoader(false);
      }
    } else {
      setLoader(false);
    }
    // const wrappedElement = document.getElementById('productList');
    // if (wrappedElement && wrappedElement.getBoundingClientRect().bottom <= window.innerHeight && props.page >= 1) {
    // if(document.getElementById("showMore")){
    //   setLoader(true);
    //   document.getElementById("showMore").click();
    // }
  };
  const handleLoadmore = () => {
    console.log(props.loading);
    if (props.loading) {
      return;
    } else if (
      props.isHasMore &&
      props.products.length !== 0 &&
      props.loading == false &&
      loader
    ) {
      props.changePage({ page: props.page + 1 });
    }
    setLoader(false);
  };

  useEffect(() => {
    document.addEventListener("scroll", isInViewport);
    return () => {
      document.removeEventListener("scroll", isInViewport);
    };
  }, []);

  useEffect(() => {
    if (isloading) {
      document.getElementById("root").classList.add("loading");
    } else {
      document.getElementById("root").classList.remove("loading");
    }
  }, [isloading]);

  useEffect(() => {
    if (props.oos === 0 || !props.oos) {
      setChecked(false);
    } else {
      setChecked(true);
    }
  }, [props.oos]);

  useEffect(() => {
    if (isAuthenticated) {
      setShowForm(false);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (props.brands.length > 0) {
      for (let i = 0; i < props.brands.length; i++) {
        if (
          window.location.pathname.split("/")[1] === "brand" &&
          window.location.pathname.split("/")[2] ===
            props.brands[i]["brand_ref_id"]
        ) {
          setBrandName(
            props.brands[i]["name"] !== null ? props.brands[i]["name"] : ""
          );
          setBrandInfo(
            props.brands[i]["description"] !== null
              ? props.brands[i]["description"]
              : ""
          );
          document.title = props.brands[i]["name"];
        }
        props.brands[i].label = props.brands[i]["name"];
        props.brands[i].value = props.brands[i]["brand_id"];
      }
    }
  }, [props.brands]);

  useEffect(() => {
    const selector = document.getElementById("isExtraData");

    if (selector === null) {
      setDisplayExpressMultiLabel(false);
    } else if (selector && !displayExpressMultiLabel) {
      createExtraLabel(selector);
    } else if (!document.querySelector(".clearFlex") && selector) {
      createExtraLabel(selector);
    }
  });

  const createExtraLabel = (selector) => {
    setDisplayExpressMultiLabel(true);
    let container = document.createElement("div");
    container.classList.add("clearFlex");
    let span = document.createElement("span");
    span.textContent = t("shop_extra_supplier_item_title");
    container.appendChild(span);
    selector.parentNode.insertBefore(container, selector);
  };

  const GetSub = () => {
    if (
      !(
        cats.includes(window.location.pathname.split("/")[1]) &&
        window.location.pathname.split("/").length === 2
      )
    ) {
      localStorage.setItem(
        "sub_cat_id",
        window.location.pathname === "/" ||
          window.location.pathname === "/best-deals/promotions"
          ? 187
          : localStorage.getItem("sub_cat_id")
          ? localStorage.getItem("sub_cat_id")
          : props.products[0]?.sub_cat_id
      );
    }
  };

  const [isFetching, setIsFetching] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setIsFetching(false);
    }, 2600);
  }, []);

  const itemsRefs = useRef({});
  
  useEffect(() => {
      if (!props.products.length) return;
      // const idsOnly = props.products.map(product => product.item_id)
      // const jsonIds = JSON.stringify(idsOnly)
      // localStorage.setItem("viewProductListRelated", jsonIds)

      const observer = new IntersectionObserver(
      (entries) => {
          entries.forEach(entry => {
              if (entry.isIntersecting) {
                  const id = entry.target.dataset.id;
                  if (onSeenProduct) {
                    onSeenProduct(id);
                  }
                  observer.unobserve(entry.target);
              }
          });
      },{
          root: null,
          rootMargin: "0px",
          threshold: 0
      }
      );

      // wire up the observer
      Object.values(itemsRefs.current).forEach(node => {
      if (node) observer.observe(node);
      });

      return () => observer.disconnect();
  }, [props.products, onSeenProduct]);

  if (
    props.category.length > 0 &&
    props.products.length === 0 &&
    window.location.pathname.split("/").indexOf("search") >= 0 &&
    props.loading === false &&
    !isFetching
  ) {
    return (
      <NoResultFound
        props={props}
        toggleFilter={toggleFilter}
        isFilterModal={isFilterModal}
        isBrandFilter={isBrandFilter}
        setSelectedBrands={setSelectedBrands}
        GetSub={GetSub}
      />
    );
  }

  const clearAllBrand = () => {
    setBrandSelected({});
    setSelected([]);
  };

  let modalClasses = `modal ${isFilterModal ? "show animate" : ""}`;
  let bgBlur = `bg_blur ${isFilterModal ? "show" : ""}`;
  return (
    <div className="d-block">
      <FilterWrapper>
        <div className={bgBlur} onClick={() => toggleFilter()}></div>
        <FilterDiv>
          <div className={`${modalClasses} row`}>
            {props.cartType !== "express" ? (
              <div style={{ padding: "0px" }} className="col-sm-eight">
                <SidebarFilter
                  brands={props.filterBrands}
                  GetSub={GetSub}
                  products={props.products}
                  setSelectedBrands={setSelectedBrands}
                  isModal={isBrandFilter}
                  ModalOpen={isFilterModal}
                  showModal={toggleFilter}
                  loading={props.loading}
                  query={queryFilter}
                />
              </div>
            ) : window.screen.width < 700 && props.cartType !== "express" ? (
              <SidebarFilter
                brands={props.filterBrands}
                GetSub={GetSub}
                products={props.products}
                setSelectedBrands={setSelectedBrands}
                isModal={isBrandFilter}
                ModalOpen={isFilterModal}
                showModal={toggleFilter}
                loading={props.loading}
                query={queryFilter}
              />
            ) : props.cartType !== "express" ? (
              <div className="_1q59bef"></div>
            ) : null}
          </div>
        </FilterDiv>
        {/* {bannerPickers()} */}
      </FilterWrapper>
      {
        <ProductsRow
          id={"productList"}
          isFullWidth={isFullWidth}
          className={props.cartType === "express" ? "ex_top" : null}
        >
          {props.FilteredNameProducts == false ? (
            props.products?.length ? (
              props.products?.map((item, index) => (
                <ProductsCol
                  key={index}
                  id={
                    typeof item.isExtraIndex !== "undefined" &&
                    item.isExtraIndex === 0
                      ? `isExtraData`
                      : null
                  }
                  data-id={item.item_id}
                  ref={el => itemsRefs.current[item.item_id] = el}
                >
                  <ProductCard
                    title={item.name}
                    description={item.about_item}
                    image={item.default_image_url}
                    weight={
                      item.store_items_price_types[0].name !== " "
                        ? item.store_items_price_types[0].name
                        : item.store_items_price_types[0].weight +
                          " " +
                          item.store_items_price_types[0].weight_unit
                    }
                    outOfStock={
                      !item.store_items_price_types[0].available_quantity
                    }
                    currency={CURRENCY}
                    price={item.store_items_price_types[0].mrp}
                    salePrice={item.store_items_price_types[0].price}
                    isSameDay={item.same_day}
                    discountInPercent={item.discountInPercent}
                    data={item}
                    deviceType={deviceType}
                    onClick={() => {
                      if (props.cartType === "express") {
                        logPageView(`/product/${item.item_ref_id}`);
                        logViewItem(item, `/product/${item.item_ref_id}`);
                        handleQuickViewModal(item, deviceType, index);
                      } else {
                        logPageView(`/product/${item.item_ref_id}`);
                        logViewItem(item, `/product/${item.item_ref_id}`);
                        history.push(`/product/${item.item_ref_id}`);
                        window.scrollTo(0, 0);
                      }
                    }}
                    onCartClick={() => {
                      document.getElementById("joinBTn").click();
                    }}
                    onUpdate={(quantity) => {
                      updateItem(item, quantity);
                    }}
                    promo={item.promo ? 1 : 0}
                    promoPrice={item.promo ? item.promo_price : null}
                    promoStartDate={item.promo ? item.promo_start_date : null}
                    promoEndDate={item.promo ? item.promo_end_date : null}
                    brandId={
                      item.brand_id === 0 || item.brand_id === null
                        ? 0
                        : item.brand_id
                    }
                    brands={props.brands}
                    loading={props.loading}
                    page={props.page}
                    productCode={item.product_code}
                  />
                </ProductsCol>
              ))
            ) : props.loading || isFetching ? (
              <Spinner animation="border" style={{ color: "#9cc54b" }} />
            ) : (
              <p>{t("error_product_not_found")}</p>
            )
          ) : null}
          {props.FilteredNameProducts == true &&
            props.filteredProducts.map((item, index) => (
              <ProductsCol key={index}>
                <ProductCardWrapper>
                  <ProductCard
                    title={item.name}
                    description={item.about_item}
                    image={item.default_image_url}
                    weight={
                      item.store_items_price_types[0].name !== " "
                        ? item.store_items_price_types[0].name
                        : item.store_items_price_types[0].weight +
                          " " +
                          item.store_items_price_types[0].weight_unit
                    }
                    outOfStock={
                      !item.store_items_price_types[0].available_quantity
                    }
                    // weight={item.store_items_price_types[0].name}
                    currency={CURRENCY}
                    price={item.store_items_price_types[0].mrp}
                    salePrice={item.store_items_price_types[0].price}
                    isSameDay={item.same_day}
                    discountInPercent={item.discountInPercent}
                    data={item}
                    deviceType={deviceType}
                    onClick={() => {
                      if (props.cartType === "express") {
                        logPageView(`/product/${item.item_ref_id}`);
                        logViewItem(item, `/product/${item.item_ref_id}`);
                        handleQuickViewModal(item, deviceType, index);
                      } else {
                        logPageView(`/product/${item.item_ref_id}`);
                        logViewItem(item, `/product/${item.item_ref_id}`);
                        history.push(`/product/${item.item_ref_id}`);
                        window.scrollTo(0, 0);
                      }
                    }}
                    onCartClick={() => {
                      document.getElementById("joinBTn").click();
                    }}
                    promo={item.promo ? 1 : 0}
                    promoPrice={item.promo ? item.promo_price : null}
                    promoStartDate={item.promo ? item.promo_start_date : null}
                    promoEndDate={item.promo ? item.promo_end_date : null}
                    brandId={
                      item.brand_id === 0 || item.brand_id === null
                        ? 0
                        : item.brand_id
                    }
                    brands={props.brands}
                    loading={props.loading}
                    page={props.page}
                    productCode={item.product_code}
                    isExtra={isExtra}
                  />
                  {/* </Fade> */}
                </ProductCardWrapper>
              </ProductsCol>
            ))}
        </ProductsRow>
      }

      {props.isHasMore &&
        props.products.length !== 0 &&
        window.location.pathname.split("/")[1] !== "best-deals" && (
          <center>
            <Button
              onClick={() => handleLoadmore()}
              type="button"
              disabled={props.loading}
              title={t("common_show_more_label", false)}
              size="small"
              intlButtonId="proceesCheckout"
              loader={<Loader />}
              isLoading={props.loading || loader}
              id={"showMore"}
              style={{
                display: props.loading || loader ? "block" : "none",
                backgroundColor: "#E6E6E6",
              }}
            />
          </center>
        )}

      {show && (
        <QuickView
          show={show}
          onHide={onHide}
          props={props}
          deviceType={deviceType}
          onCartClick={() => {
            handleJoin();
          }}
        />
      )}
      <Modal
        show={showform}
        onHide={() => setShowForm(false)}
        dialogClassName="modal-90w authModal"
        aria-labelledby="example-custom-modal-styling-title"
        backdrop="static"
      >
        <Modal.Header closeButton style={{ border: 0 }}></Modal.Header>
        <Modal.Body style={{ padding: 0 }}>
          <AuthenticationForm />
        </Modal.Body>
      </Modal>
      <Modal
        show={isBrandFilter}
        onHide={onClose}
        aria-labelledby="example-custom-modal-styling-title"
        size="lg"
        animation={true}
        centered
      >
        <Modal.Header
          closeButton
          style={{ padding: ".4rem 1rem" }}
        ></Modal.Header>
        <Modal.Body style={{ padding: 0 }}>
          <FilterModalWrapper>
            <div className="_pwbsgx">
              <div className="_1qbrhv4">
                <button
                  onClick={clearAllBrand}
                  disabled={
                    isBrandSelected && Object.keys(isBrandSelected).length
                      ? false
                      : true
                  }
                  type="button"
                  className="_gby1jkw"
                >
                  {t("shop_item_filter_clear_button")}
                </button>
                <div className="_ls0e43">
                  <button
                    onClick={() => setSelectedBrands()}
                    type="button"
                    className="_ajuxzjo"
                  >
                    {t("shop_item_filter_save_button")}
                  </button>
                </div>
              </div>
            </div>
          </FilterModalWrapper>
        </Modal.Body>
      </Modal>

      <Modal
        show={showFilterNotFound}
        onHide={() => setShowFilterNotFound(false)}
        centered
      >
        <Modal.Body className="text-center">
          <ErrorModal>
            <p>{t("common_no_products_found_label")}</p>
            <Button
              size="sm btn-sm"
              title={t("button_close_label")}
              className="cancelBtn express"
              variant="success"
              onClick={() => setShowFilterNotFound(false)}
            />
          </ErrorModal>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Products;
